import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '@nebula-shared/data-access';

@Component({
  selector: 'app-detalle-deduccion-summary',
  imports: [CommonModule],
  templateUrl: './detalle-deduccion-summary.component.html',
  styleUrl: './detalle-deduccion-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetalleDeduccionSummaryComponent {
  translation = inject(TranslationService);

  t(key: string): string {
    return this.translation.translate(key);
  }

  valorTotalDeducido = input<number>(0);
  valorPorDeducir = input<number>(0);
  totalCuotas = input<number>(0);
  cuotasPagadas = input<number>(0);
  cuotasPendientes = input<number>(0);

  readonly saldoCero = computed(() => this.valorPorDeducir() === 0);
  readonly tieneCuotas = computed(() => this.totalCuotas() > 0);
}
